// Badge options for Multi Agent column
export const MULTI_AGENT_BADGE_OPTIONS = [
  {
    id: "yes",
    text: "Yes",
    textColor: "#005D49",
    bgColor: "#E6F3F0", // Green color
    borderColor: "#005D49", // Green border
  },
  {
    id: "no",
    text: "No",
    textColor: "#374151",
    bgColor: "#F3F4F6", // Light gray background matching the green style
    borderColor: "#374151", // Gray border
  },
];

// Badge options for Type column
export const TYPE_BADGE_OPTIONS = [
  {
    id: "agentic",
    text: "Agentic",
    textColor: "#0056D6",
    bgColor: "#EAF2FF",
    borderColor: "#0056D6", // Blue border
  },
  {
    id: "human",
    text: "Human",
    textColor: "#665D00",
    bgColor: "#FFFCD6",
    borderColor: "#665D00", // Yellow border
  },
];
